import { render, staticRenderFns } from "./KanomTransfer.vue?vue&type=template&id=e26f74d4&"
import script from "./KanomTransfer.vue?vue&type=script&lang=js&"
export * from "./KanomTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports